import { BaseLayoutFactory } from "../global/base-layout-factory";
import { PublicationDetailComponent } from "./publication-detail-component";
import { PublicationDetailProvider } from "./context/publication-detail-context";

export function PublicationDetailFactory() {
    return (
        <BaseLayoutFactory>
            <PublicationDetailProvider>
                <PublicationDetailComponent />
            </PublicationDetailProvider>
        </BaseLayoutFactory>
    );
}
